import { css, jsx } from '@emotion/react';
import { Typography } from '@zapier/design-system';
import { Section, Header } from 'react-aria-components';

const HeaderStyles = css(Object.assign({ padding: "var(--zds-space-8, 10px)" }, Typography.Body3));
const SectionStyles = css({
  "& div[role='option']": {
    paddingLeft: "var(--zds-space-20, 20px)"
  }
});
const SelectGroup = ({ children, className, label }) => {
  return jsx(
    Section,
    { css: SectionStyles, className, "data-zds": true },
    jsx(Header, { css: HeaderStyles, "data-zds": true }, label),
    children
  );
};

export { SelectGroup };
//# sourceMappingURL=SelectGroup.es.js.map
